import $ from 'jquery';
import { getInputValue } from '../utils/input';
import { matchesCriteria } from '../utils/criteria';
const ELEMENT_SELECTOR = '.js__required-on-target-value';
export class RequiredOnTargetValue {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        $elements.each((index, element) => {
            let $element = $(element);
            if ($element.hasClass('ui dropdown') && $element.find('select').length) {
                $element = $element.find('select');
            }
            const targetSelectors = $element.data('required-target').split(',');
            targetSelectors.forEach((targetSelector) => {
                let $target = this.getTarget(targetSelector, $element);
                $target.on('change', event => {
                    this.handleValueChange($(event.target), $element);
                });
                this.handleValueChange($target, $element);
            });
        });
    }
    static getTarget(selector, $element) {
        let $target = $(selector);
        if ($target.hasClass('ui dropdown') && $target.find('input').length) {
            $target = $target.find('input');
        }
        return $target;
    }
    static handleValueChange($target, $element) {
        const { requiredCriteriaValue, requiredTarget } = $element.data();
        let isRequired;
        const targetSelectors = requiredTarget.split(',');
        if (targetSelectors.length) {
            isRequired = targetSelectors.some((targetSelector) => {
                let $target = this.getTarget(targetSelector, $element);
                return matchesCriteria(requiredCriteriaValue, getInputValue($target));
            });
        }
        else {
            const value = getInputValue($target);
            isRequired = matchesCriteria(requiredCriteriaValue, value);
        }
        this.setRequiredField($element, isRequired);
    }
    static setRequiredField($element, isRequired) {
        const $field = $element.closest('.field');
        $field.toggleClass('required', isRequired);
    }
}
